import { getDeviceIdentity } from './sync';

type ClientHints = { platform?: string; mobile?: boolean; model?: string; getHighEntropyValues?: (hints: string[]) => Promise<{ model?: string; platformVersion?: string; fullVersionList?: Array<{ brand: string; version: string }> }> };

function browserName(userAgent: string) {
  if (/Edg\//.test(userAgent)) return 'Microsoft Edge';
  if (/OPR\//.test(userAgent)) return 'Opera';
  if (/Firefox\//.test(userAgent)) return 'Firefox';
  if (/CriOS\//.test(userAgent)) return 'Chrome iOS';
  if (/Chrome\//.test(userAgent)) return 'Google Chrome';
  if (/Safari\//.test(userAgent)) return 'Safari';
  return 'Unknown browser';
}

function platformName(userAgent: string, platform: string) {
  if (/Android/i.test(userAgent)) return 'Android';
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'iOS / iPadOS';
  if (/Windows/i.test(userAgent)) return 'Windows';
  if (/Macintosh|Mac OS X/i.test(userAgent)) return 'macOS';
  if (/Linux/i.test(userAgent)) return 'Linux';
  return platform || 'Unknown platform';
}

export async function registerCurrentDevice() {
  if (!navigator.onLine) return;
  const hints = (navigator as Navigator & { userAgentData?: ClientHints }).userAgentData;
  const highEntropy = await hints?.getHighEntropyValues?.(['model', 'platformVersion', 'fullVersionList']).catch(() => undefined);
  const userAgent = navigator.userAgent.slice(0, 500);
  const platform = platformName(userAgent, hints?.platform || navigator.platform || '');
  const browser = highEntropy?.fullVersionList?.map((item) => `${item.brand} ${item.version}`).join(', ') || browserName(userAgent);
  const model = highEntropy?.model?.trim();
  const screenSize = `${screen.width}×${screen.height}`;
  const payload = {
    platform, browser: browser.slice(0, 180), userAgent, language: navigator.language || 'unknown',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown', screenWidth: screen.width,
    screenHeight: screen.height, viewportWidth: window.innerWidth, viewportHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio || 1, touchPoints: navigator.maxTouchPoints || 0,
    cpuCores: navigator.hardwareConcurrency || null,
    memoryGb: (navigator as Navigator & { deviceMemory?: number }).deviceMemory || null,
    connectionType: (navigator as Navigator & { connection?: { effectiveType?: string } }).connection?.effectiveType || '',
    deviceLabel: model ? `${platform} · ${model}` : `${platform} · ${screenSize}`
  };
  const signature = JSON.stringify(payload);
  try {
    const { deviceId } = await getDeviceIdentity();
    const response = await fetch('/api/device', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ deviceId, signature, ...payload }) });
    if (!response.ok) return;
  } catch { /* Device telemetry must never block the daily-sales flow. */ }
}
